import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../providers/TacticHooksProvider";

export function useCalendarByResource(resourceId: string | null) {
  const { apiClient } = useTacticHooks();
  const {
    data: calendar,
    error,
    isLoading
  } = useQuery({
    queryKey: ["integrations.calendar", resourceId],

    queryFn: async () => {
      const res = await apiClient.calendar.getCalendarByResourceId(
        resourceId as string
      );
      return res.result;
    },

    enabled: !!resourceId,

    meta: {
      shouldIgnoreGlobalErrorHandler: true
    }
  });
  return { calendar, isLoading, error };
}
